export const API_TUTORIAL_REQUEST = 'API_TUTORIAL_REQUEST';
export const API_TUTORIAL_SUCCESS = 'API_TUTORIAL_SUCCESS';
export const API_TUTORIAL_FAILURE = 'API_TUTORIAL_FAILURE';

export const API_DONT_SHOW_TUTORIAL_REQUEST = 'API_DONT_SHOW_TUTORIAL_REQUEST';
export const API_DONT_SHOW_TUTORIAL_SUCCESS = 'API_DONT_SHOW_TUTORIAL_SUCCESS';
export const API_DONT_SHOW_TUTORIAL_FAILURE = 'API_DONT_SHOW_TUTORIAL_FAILURE';

export const tutorialRequest = () => ({
  type: API_TUTORIAL_REQUEST,
});

export const tutorialSuccess = payload => ({
  type: API_TUTORIAL_SUCCESS,
  payload,
});

export const tutorialFailure = payload => ({
  type: API_TUTORIAL_FAILURE,
  payload,
});

export const dontShowTutorialRequest = () => ({
  type: API_DONT_SHOW_TUTORIAL_REQUEST,
});

export const dontShowTutorialSuccess = payload => ({
  type: API_DONT_SHOW_TUTORIAL_SUCCESS,
  payload,
});

export const dontShowTutorialFailure = payload => ({
  type: API_DONT_SHOW_TUTORIAL_FAILURE,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  tutorial: null,
  dontShowTutorial: false,
};

export function tutorialReducer(state = initialState, action) {
  switch (action.type) {
    case API_TUTORIAL_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_TUTORIAL_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        tutorial: action.payload,
      };
    case API_TUTORIAL_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    case API_DONT_SHOW_TUTORIAL_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_DONT_SHOW_TUTORIAL_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        dontShowTutorial: true,
      };
    case API_DONT_SHOW_TUTORIAL_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}
